// destinations img
import tour4 from "../assets/images/tour/Tokyo.png";
import tour5 from "../assets/images/tour/bali-1.png";
import tour6 from "../assets/images/tour/bangkok.png";
import tour7 from "../assets/images/tour/cancun.png";
import tour8 from "../assets/images/tour/nah-trang.png";
import tour9 from "../assets/images/tour/phuket.png";
import tour10 from "../assets/images/tour/paris.png";
import tour11 from "../assets/images/tour/malaysia.png";

// populars img


import dhikalaImg from "../assets/images/feature/dhikala.jpeg";
// import jimCorbettPackageImg from "../assets/images/feature/jimcorbettpackage.jpeg";
import nainitalImg from "../assets/images/feature/nainital.jpeg";
import safariCorbettImg from "../assets/images/feature/safaricorbett.jpeg";
import tigeryes from "../assets/images/feature/tigeryes.jpg";  // For homepage card
import package1 from "../assets/inside/package1.jpg";   // For details page hero
import package2 from "../assets/inside/package2.jpg";   // For card image
import package3 from "../assets/inside/package3.jpg";     // For details page hero
import package4 from "../assets/inside/package4.jpg";     // For details page hero
import package5 from "../assets/inside/package5.jpg";     // For details page hero

// tour detail img
import image1 from "../assets/images/new/1.jpg";
import image2 from "../assets/images/new/2.jpg";
import image3 from "../assets/images/new/3.jpg";
import image4 from "../assets/images/new/4.jpg";
import image5 from "../assets/images/new/5.jpg";
import image6 from "../assets/images/new/6.jpg";
import image7 from "../assets/images/new/7.jpg";
import image8 from "../assets/images/new/8.jpg";

// Safari images



export const destinationsData = [
  {
    id: 0,
    name: "Bali",
    tours: "5 tours and activities",
    image: tour5,
    link: "tour-name",
    shortDes: "",
  },
  {
    id: 1,
    name: "Tokyo",
    tours: "9 tours and activities",
    image: tour4,
    link: "tour-name",
  },

  {
    id: 2,
    name: "Bangkok",
    tours: "5 tours and activities",
    image: tour6,
    link: "tour-name",
  },

  {
    id: 3,
    name: "Cancun",
    tours: "4 tours and activities",
    image: tour7,
    link: "tour-name",
  },
  {
    id: 4,
    name: "Nha Trang",
    tours: "9 tours and activities ",
    image: tour8,
    link: "tour-name",
  },
  {
    id: 5,
    name: "Phuket",
    tours: "4 tours and activities",
    image: tour9,
    link: "tour-name",
  },
  {
    id: 6,
    name: "Paris",
    tours: "6 tours and activities",
    image: tour10,
    link: "tour-name",
  },
  {
    id: 7,
    name: "Malaysia",
    tours: "4 tours and activities",
    image: tour11,
    link: "tour-name",
  },
];

export const popularsData = [
  {
    id: 4,
    title: "The Wild Welcome Escape",
    image: tigeryes,      // This will show on the homepage card
    heroImage: package3,  // This will show on the details page
    location: "Corbett National Park, Uttarakhand",
    category: ["Tour & Package"],
    days: "2N/3D",
    price: 4999,
    afterDiscount: 0,
    rating: 4.5,
    reviews: 9,
    description: "2 Nights / 3 Days of Safari Thrills, Riverside Peace & Spiritual Vibes By Corbett Aura",
    highlights: [
      "Perfect for families, couples, and weekend travellers",
      "Nature + Wildlife + Peaceful Retreat — all in one package",
    ],
    itinerary: [
      {
        title: `<span class="me-1 fw-bold">Day 1:</span> Arrival • Jungle Safari • Poolside Serenity`,
        des: "Arrival & Check-In: Arrive at your pre-booked hotel/resort in Jim Corbett. Receive a warm welcome and get settled in your room surrounded by forest vibes. Lunch at the Property: Enjoy a delicious lunch prepared with local Flavors and seasonal ingredients. Afternoon Jeep Safari: Board your open jeep and head into the heart of Jim Corbett National Park for a thrilling 3-hour safari. Spot deer, wild elephants, peacocks, exotic birds — and if you're lucky, the majestic Bengal Tiger. Evening Tea by the Pool: Return to the hotel and relax with a cup of tea by the poolside as the sun sets over the jungle. Peaceful Evening & Dinner: Enjoy the calm of nature. Walk around the property, listen to birdsong, or simply rest. Later, indulge in a delightful dinner before retiring for the night."
      },
      {
        title: `<span class="me-1 fw-bold">Day 2:</span> Morning Safari • Resort Activities`,
        des: "Morning Safari: Start your day with an early morning safari into the wilderness. Your expert naturalist will help you spot and identify various wildlife species in their natural habitat. Return for Breakfast: Come back to a hearty breakfast at the resort. Day at Leisure: Spend the day enjoying resort activities - take a dip in the pool, go for nature walks around the property, or simply relax in the peaceful surroundings. Evening Entertainment: Gather around for a cozy bonfire (weather permitting) and enjoy dinner under the stars. Overnight stay at the resort."
      },
      {
        title: `<span class="me-1 fw-bold">Day 3:</span> Breakfast • Departure`,
        des: "Morning Refresh: Start your day at your own pace. Breakfast at the Hotel: Enjoy a fulfilling breakfast while reminiscing about your jungle adventures. Checkout: With wonderful memories of your Corbett adventure, bid farewell to the wilderness."
      }
    ],
    included: [
      "2 Nights stay in nature-themed resort accommodation",
      "All meals (2 Breakfasts, 2 Lunches, 2 Dinners, Tea/Coffee)",
      "1 Jeep Safari (Day 1 Afternoon)",
      "1 Dhikala Canter Safari (Day 2 Morning)",
      "Visit to riverbanks or Hanuman Dham (optional)",
      "Access to pool, gardens, and leisure areas",
      "All Taxes & Service Charges"
    ],
    addOns: [
      "Bonfire arrangements",
      "Pickup/drop from Ramnagar",
      "Candlelight dinner",
      "Guided nature walks",
      "Professional wildlife photography"
    ]
  },
  {
    id: 5,
    title: "Corbett Aura Express",
    image: package2,      // This will show on the homepage card
    heroImage: package1,  // This will show on the details page
    location: "Corbett National Park, Uttarakhand",
    category: ["Tour & Package"],
    days: "1N/2D",
    price: 4999,
    afterDiscount: 0,
    rating: 4.5,
    reviews: 9,
    description: "1N/2D Safari Special - Experience the wilderness of Jim Corbett with a perfect mix of adventure & relaxation.",
    highlights: [
      "Perfect for families, couples, and weekend travellers",
  "Nature + Wildlife + Peaceful Retreat — all in one package",

    ],
    itinerary: [
      {
        title: "Day 1: Arrival • Jungle Safari • Poolside Serenity",
        des: "Arrival & Check-In: Arrive at your pre-booked hotel/resort in Jim Corbett. Receive a warm welcome and get settled in your room surrounded by forest vibes. Lunch at the Property: Enjoy a delicious lunch prepared with local Flavors and seasonal ingredients. Afternoon Jeep Safari: Board your open jeep and head into the heart of Jim Corbett National Park for a thrilling 3-hour safari. Spot deer, wild elephants, peacocks, exotic birds — and if you're lucky, the majestic Bengal Tiger. Evening Tea by the Pool: Return to the hotel and relax with a cup of tea by the poolside as the sun sets over the jungle. Peaceful Evening & Dinner: Enjoy the calm of nature. Walk around the property, listen to birdsong, or simply rest. Later, indulge in a delightful dinner before retiring for the night."
      },
      {
        title: "Day 2: Morning Bliss • Optional Temple Visit • Breakfast & Checkout",
        des: "Morning Refresh: Start your day your way: Take a refreshing dip in the pool OR Head out on your own to visit the nearby Garjia Devi Temple or Hanuman Dham– two of Corbett's most serene spiritual spots, perfect for offering prayers or simply soaking in the calm atmosphere. Breakfast at the Hotel: After your morning activity, enjoy a hearty breakfast to fuel up for the day. Checkout: With your heart full and camera roll packed, check out from the hotel with memories that'll stay wild forever."
      }
    ],
    included: [
      "1 Night Accommodation in 3 Star Resort",
      "All Meals: Lunch, Dinner & Breakfast",
      "1 Exclusive Jeep Safari with permits ",
      "expert guide",
      "Evening Tea by the Pool",
      "Use of Swimming Pool",
      "Optional Visit to Garjia Devi Temple or Hanuman Dham Morning Aarti",
      "All Taxes & Service Charges"
    ],
    addOns: [
    "  Customizable on request (add extra night, more safaris, or transfers)"


    ]
  },
  {
    id: 6,
    title: "Dhikala Serenity Escape",
    image: nainitalImg,
    heroImage: package4,
    location: "Corbett National Park, Uttarakhand",
    category: ["Tour & Package"],
    days: "2N/3D",
    price: 6999,
    afterDiscount: 0,
    rating: 5,
    reviews: 18,
    description: "2 Nights / 3 Days of Scenic Safari, Sacred Moments & Riverside Calm By Corbett Aura",
    highlights: [
      "Perfect for families, couples, and weekend travellers",
  "Nature + Wildlife + Peaceful Retreat — all in one package",
  "Customizable on request (add extra night, more safaris, or transfers) ",
    ],
    itinerary: [
      {
        title: `<span class="me-1 fw-bold">Day 1:</span> Arrival & Peaceful Beginnings`,
        des: `Arrive at Corbett on your own. Check-in at the Resort and settle into your room. Enjoy lunch followed by leisure time to relax. Evening by the poolside with calm music. Dinner served in a cozy indoor or outdoor setting. Overnight stay at resort.`
      },
      {
        title: `<span class="me-1 fw-bold">Day 2:</span> Dhikala Safari & Spiritual Evening`,
        des: `Early morning Dhikala Canter Safari with expert guides to explore the most scenic zone of Jim Corbett. Return for breakfast. Afternoon at leisure - relax, read, or enjoy the resort amenities. Evening visit options: peaceful walk along Ramnagar riverbanks or attend evening aarti at Hanuman Dham. Dinner and overnight stay at resort.`
      },
      {
        title: `<span class="me-1 fw-bold">Day 3:</span> Farewell with Calm`,
        des: `Breakfast at resort. Free time to relax and enjoy the resort facilities. Check-out with wonderful memories of Dhikala zone and Corbett.`
      }
    ],
    included: [
      "2 Nights Accommodation in Resort",
      "All Meals: Breakfast, Lunch & Dinner",
      "1 Dhikala Canter Safari ",
      "Adventure Zone Activities",
      "Evening Entertainment",
      "All Taxes & Service Charges"
    ],
    addOns: [
      "Bonfire with soft music",
      "Photography sessions",
      "River picnic setup",
      "Candlelight dinner",
      "Pickup & drop from Ramnagar station"
    ]
  },
  {
    id: 7,
    title: "The Aura Escape",
    image: safariCorbettImg,    // Keep current card image
    heroImage: package5,            // Add package5 as hero image
    location: "Corbett National Park, Uttarakhand",
    category: ["Tour & Package"],
    days: "2N/3D",
    price: 7999,
    afterDiscount: 0,
    rating: 4.8,
    reviews: 12,
    description: "2 Nights of Safari, Serenity & Soulful Moments. A perfect blend of adventure, nature, and peace – unwind in the wild while enjoying all the comforts of a relaxing retreat.",
    highlights: [
      "Perfect for families, couples, and weekend travellers",
      "Nature + Wildlife + Peaceful Retreat — all in one package",
      "Customizable on request (add extra night, more safaris, or transfers) ",
    ],
    itinerary: [
      {
        title: `<span class="me-1 fw-bold">Day 1:</span> Welcome to Tranquillity`,
        des: `Reach Corbett on your own. Check-in at the Resort and settle into your serene room with nature views. Enjoy lunch followed by leisure time to relax and explore the resort. Evening by the poolside with calm music. Dinner served in a cozy indoor or outdoor setting. Overnight stay at resort.`
      },
      {
        title: `<span class="me-1 fw-bold">Day 2:</span> Safari & Scenic Moments`,
        des: `Early morning jeep safari with expert guides to witness wildlife. Return for breakfast. Afternoon at leisure - relax, read, or enjoy the gardens. Evening tea by the pool. Optional visit to Kosi River Banks. Dinner with optional bonfire (seasonal). Overnight stay at resort.`
      },
      {
        title: `<span class="me-1 fw-bold">Day 3:</span> Temple Visit & Departure`,
        des: `Optional morning visit to either Garjia Temple or Hanuman Dham. Return for breakfast at resort. Check-out with memories to cherish.`
      }
    ],
    included: [
      "2 Nights accommodation in a nature resort",
      "All meals (Lunch, Dinner, Breakfast, Evening Tea)",
      "1 Early morning Jeep Safari with entry & guide",
      "Optional evening visit to Kosi River or Hanuman Dham",
      "Pool access, peaceful nature walks, and garden sitting area"
    ],
    addOns: [
    "  Bonfire & light music evening",

     " Candlelight dinner setup"
    ]
  },
];

export const tourDetails = {
  title: "Beautiful Bali with Malaysia",
  des: ` Bali, also known as the land of gods has plenty to offer to travelers from across the globe. As it so contrasted oh estimating instrument. Size like body some one had.  Are conduct viewing boy minutes warrant the expense?  Tolerably behavior may admit daughters offending her ask own. Praise effect wishes change way and any wanted.  Lively use looked latter regard had. Do he it part more  last in. We understand that theory is important to build a solid foundation, we understand that theory alone isn’t going to get the job done so that’s why this is packed with practical hands-on examples that you can  follow step by step.`,
  price: "280.00",
  rating: " 4.5",
  reviews: "365 reviews",
  tourInfo: [
    '<strong className="font-bold"> Place Covered</strong>: Bali - Ubud',
    ' <strong className="font-bold">Duration:</strong>5 Days, 4 Nights',
    '<strong className="font-bold">Start Point:</strong> Ngurah International Airport',
    '<strong className="font-bold">End Point:</strong>  Ngurah International Airport',
  ],

  highlights: [
    " Experience a delightful tropical getaway with a luxurious stay and witness the picture-perfect beaches, charming waterfalls and so much more",
    " Dependent on so extremely delivered by. Yet no jokes  worse her why. Bed one supposing breakfast day fulfilled off depending questions.",
    " Whatever boy her exertion his extended. Ecstatic  followed handsome drawings entirely Mrs one yet  outweigh.",
    "Meant balls it if up doubt small purse. Required his  you put the outlived answered position. A pleasure exertion if believed provided to.",
  ],

  itinerary: [
    {
      title: `<span class="me-1 fw-bold">Day 1:</span>  Airport Pick Up `,
      des: ` Like on all of our trips, we can collect you from the airport when you land and take you directly to your hotel. The first Day is just a check-in Day so you have this freedom to explore the city and get settled in.`,
    },

    {
      title: `<span class="me-1 fw-bold">Day 2:</span>  Temples & River Cruise `,
      des: ` Like on all of our trips, we can collect you from the airport when you land and take you directly to your hotel. The first Day is just a check-in Day so you have this freedom to explore the city and get settled in. `,
    },
    {
      title: `<span class="me-1 fw-bold">Day 3:</span>  Massage & Overnight Train`,
      des: ` Like on all of our trips, we can collect you from the airport when you land and take you directly to your hotel. The first Day is just a check-in Day so you have this freedom to explore the city and get settled in.`,
    },
    {
      title: `<span class="me-1 fw-bold">Day 4:</span>  Khao Sok National Park `,
      des: ` Like on all of our trips, we can collect you from the airport when you land and take you directly to your hotel. The first Day is just a check-in Day so you have this freedom to explore the city and get settled in.`,
    },
    {
      title: `<span class="me-1 fw-bold">Day 5:</span>  Travel to Koh Phangan `,
      des: ` Like on all of our trips, we can collect you from the airport when you land and take you directly to your hotel. The first Day is just a check-in Day so you have this freedom to explore the city and get settled in.
      `,
    },
    {
      title: `<span class="me-1 fw-bold">Day 6:</span> Morning Chill & Muay Thai Lesson `,
      des: `Like on all of our trips, we can collect you from the airport when you land and take you directly to your hotel. The first Day is just a check-in Day so you have this freedom to explore the city and get settled in.
      `,
    },
  ],

  included: [
    "Comfortable stay for 4 nights in your preferred category Hotels",
    "Professional English speaking guide to help you explore the cities",
    "Breakfast is included as mentioned in Itinerary.",
    "Per Peron rate on twin sharing basis",
    "Entrance Tickets to Genting Indoor Theme Park    ",
    "All Tours & Transfers on Seat In Coach Basis ",
    "Visit Bali Safari & Marine Park with Jungle Hopper Pass    ",
  ],
  exclusion: [
    "Lunch and dinner are not included in CP plans",
    "Any other services not specifically mentioned in the inclusions",
    "Medical and Travel insurance",
    "Airfare is not included ",
    "Early Check-In & Late Check-Out ",
    "Anything which is not specified in Inclusions    ",
  ],

  images: [
    {
      original: image1,
      thumbnail: image1,
    },
    {
      original: image2,
      thumbnail: image2,
    },
    {
      original: image3,
      thumbnail: image3,
    },
    {
      original: image4,
      thumbnail: image4,
    },
    {
      original: image5,
      thumbnail: image5,
    },

    {
      original: image6,
      thumbnail: image6,
    },
    {
      original: image7,
      thumbnail: image7,
    },
    {
      original: image8,
      thumbnail: image8,
    },
  ],
};

export const location = [
  "Bali",
  "Tokyo",
  "Bangkok",
  "Cancun",
  "Nha Trang",
  "Phuket",
  "Malaysia",
  "Paris",
];

export const Categories = [
  "History",
  "Calture",
  "Netural",
  "Urban Tour",
  "Relax",
];

export const Duration = ["1-3 Days", "3-5 Days", "5-7 Days", "7-10 Day"];
export const PriceRange = [
  "₹ 0 - ₹50",
  "₹ 50 - ₹ 100",
  "₹ 100 - ₹ 200",
  "₹ 200 - ₹ 400",
  "₹ 400 - ₹ 800",
];

export const Ratings = ["⭐", "⭐⭐", "⭐⭐⭐", "⭐⭐⭐⭐", "⭐⭐⭐⭐⭐"];

export const safariData = [
  {
    id: 1,
    title: "Dhikala Safari",
    image: dhikalaImg,
    location: "Corbett National Park, Uttarakhand",
    category: ["Safari"],
    duration: "Morning Safari",
    price: 2999,
    rating: 4.8,
    reviews: 15,
    highlights: [
      "Most popular safari zone",
      "Highest tiger density",
      "Grassland habitat",
      "Elephant sightings common"
    ],
    description: "Dhikala is the most sought-after zone in Jim Corbett National Park. Located in the core area, it offers the best chances of spotting tigers and other wildlife. The zone features vast grasslands, dense sal forests, and the scenic Ramganga reservoir. Morning safaris typically start at sunrise and last for 4 hours.",
    timings: "5:30 AM - 9:30 AM",
    meetingPoint: "Dhikala Forest Gate",
    includes: [
      "Experienced naturalist guide",
      "4x4 Jeep safari vehicle",
      "Entry permits and forest fees",
      "Bottled water"
    ],
    instructions: [
      "Carry valid ID proof",
      "Wear earth-colored clothing",
      "No flash photography allowed",
      "Follow guide's instructions"
    ]
  }
];
